import { groq } from '#imports';

export function getQuery() {
  return groq`*[_type == "about" && !(_id in path('drafts.**'))][0]{
  title,
  content,
  ogImage,
  }`;
}
